var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreLocatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.458c-1.19 0-2.156-.965-2.156-2.156 0-1.19.965-2.156 2.156-2.156 1.19 0 2.156.965 2.156 2.156 0 1.19-.965 2.156-2.156 2.156m-4.963 5.53l4.607 8.048c.08.171.257.282.452.282.197 0 .376-.113.454-.288l5.669-10.226c.22-.396.41-.808.546-1.238.85-2.675-.02-5.645-2.342-7.411-1.205-.917-2.73-1.473-4.424-1.473-1.698 0-3.228.56-4.434 1.48-2.263 1.729-3.139 4.602-2.384 7.223.15.523.377 1.022.65 1.497l1.206 2.107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLocatorIcon);
export default __webpack_public_path__ + "static/media/store-locator-icon.5da5f829.svg";
export { ForwardRef as ReactComponent };